import { partners as defaultPartners } from "@/data/partners";
import { ScrollReveal } from "@/components/scroll-reveal";
import { useSiteSettings } from "@/lib/cms";
import { fileUrl } from "@/lib/format";

const LOGO_CLASS =
  "h-12 w-auto max-w-[140px] object-contain opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300";

export function PartnersSection() {
  const settings = useSiteSettings();

  // Admin-curated list (site settings) — rows that carry neither a name nor a
  // logo are skipped. When the list is empty/absent, fall back to the built-in
  // logo set so existing sites are unchanged until the admin edits it.
  const customItems = (settings.partners?.items ?? []).filter(
    (p) => p.name.trim() !== "" || p.logoKey || p.builtinSrc,
  );
  const title = settings.partners?.title?.trim() || "Partnereink";

  return (
    <section
      aria-labelledby="partners-heading"
      data-preview-section="partners"
      className="relative py-20 lg:py-28 bg-white section-titled overflow-hidden scroll-mt-24"
    >
      <div className="section-watermark uppercase">márka</div>
      <div className="container relative z-10">
        <ScrollReveal className="text-center mb-12">
          <h2
            id="partners-heading"
            className="text-2xl sm:text-3xl lg:text-4xl font-heading font-normal uppercase text-brand-700 tracking-ultrawide leading-tight"
          >
            {title}
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <div className="flex flex-wrap justify-center items-center gap-10 lg:gap-14">
            {customItems.length > 0
              ? customItems.map((p, i) =>
                  p.logoKey || p.builtinSrc ? (
                    <img
                      key={`${p.name}-${i}`}
                      src={p.logoKey ? fileUrl(p.logoKey) : p.builtinSrc}
                      alt={p.name}
                      width={160}
                      height={60}
                      loading="lazy"
                      className={LOGO_CLASS}
                    />
                  ) : (
                    <span
                      key={`${p.name}-${i}`}
                      className="font-heading text-lg uppercase tracking-widest text-brand-400 opacity-70 hover:opacity-100 transition-opacity duration-300"
                    >
                      {p.name}
                    </span>
                  ),
                )
              : defaultPartners.map((p) => (
                  <img
                    key={p.name}
                    src={p.src}
                    alt={p.name}
                    width={160}
                    height={60}
                    loading="lazy"
                    className={LOGO_CLASS}
                  />
                ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
